import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment.test';

import { EstablishmentJson } from './microservices/json/Establishment.json';
import { EstablishmentSimpleJson } from './microservices/json/establishment-simple.json';
import { IdNumberJson } from './microservices/json/id-number.json';
import { MicroResponse } from './microservices/response/micro.response';
import { RequestService } from './request.service';

@Injectable({ providedIn: 'root' })
export class EstablishmentService {
  private endpoint = `${environment.IDEMPIER_GATEWAY}/v1/establishment`;
  private requestService = inject(RequestService);
  private http = inject(HttpClient);

  get(id: number): Observable<MicroResponse<EstablishmentJson>> {
    return this.http.get<MicroResponse<EstablishmentJson>>(
      `${this.endpoint}/${id}`,
    );
  }

  getBySignatureIdObs(
    signatureId: number,
  ): Observable<MicroResponse<Array<EstablishmentSimpleJson>>> {
    return this.http.get<MicroResponse<Array<EstablishmentSimpleJson>>>(
      this.endpoint +
        `/projection?fields=id,tradeName,branchOffice&signatureId=${signatureId}`,
    );
  }

  async getBySignatureId(
    signatureId: number,
  ): Promise<Array<EstablishmentSimpleJson>> {
    const request = lastValueFrom(this.getBySignatureIdObs(signatureId));
    return (await this.requestService.handleRequest(request)).data;
  }

  save(params: FormData): Observable<MicroResponse<IdNumberJson>> {
    return this.http.post<MicroResponse<IdNumberJson>>(this.endpoint, params);
  }

  update(params: FormData): Observable<MicroResponse<IdNumberJson>> {
    return this.http.put<MicroResponse<IdNumberJson>>(this.endpoint, params);
  }
}
